import * as React from "react";
import * as moment from "moment";
import {Link, Navigate} from "react-router-dom";
import {
    AnnualPolicyPremiumTypeEnum,
    CommonHelpers,
    FalconNavigatorHeader,
    INTERACTION_PROCESS_CLAIM_IMPACT,
    INTERACTION_PROCESS_MTA_EDIT_CAR_DETAILS,
    INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE,
    INTERACTION_PROCESS_MTA_REPLACE_CAR,
    INTERACTION_PROCESS_MTC,
    INTERACTION_PROCESS_NB,
    INTERACTION_PROCESS_PENDING_RENEWAL,
    INTERACTION_PROCESS_PENDING_RENEWAL_DD,
    INTERACTION_PROCESS_RENEWAL,
    InteractionHelper,
    NEW_PAYMENT,
    PaymentCard,
    Policy,
    POLICY_STATUS_MTC,
    POLICY_STATUS_PENDING_RENEWAL,
    POLICY_STATUS_UNDERWRITING_FAILURE,
    PolicyProperty,
    PolicyPropertyEnum,
    PREMIUM_TYPE_ANNUAL,
    PREMIUM_TYPE_MONTHLY,
    ProductsEnum,
    Renewal,
    RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL,
    resourcesHelper,
    SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED,
} from "@falcon/services";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {AnnualProductPaymentMessageBanner} from "../../../../../components/banners/AnnualProductPaymentMessageBanner";
import {BackButton} from "../../../../../components/navigation/BackButton";
import {UnpaidChangeBanner} from "../../../../../components/banners/UnpaidChangeBanner";
import * as Driver from "driver.js";
import {finalize} from "rxjs/operators";
import {ChargebackBanner} from "../../../../../components/banners/ChargebackBanner";
import {CardExpiryBanner} from "../../../../../components/banners/CardExpiryBanner";
import {
    findMainAnnualPaymentCardByMainCardId,
    findPreviousPolicyVersionByAgreementVersion,
    formatDateDMY,
    formatDateTime,
    getAmountToDisplay,
    getSessionStorage,
    isAllianzAdvantagesToggleEnabled,
    setSessionStorage
} from "../../../../../CommonFunctions";
import * as MobileDetect from "mobile-detect";
import {NextYearAutoRenewalBanner} from "../../../../../components/banners/NextYearAutoRenewalBanner";
import {PolicyWillBeRenewedBanner} from "../../../../../components/banners/PolicyWillBeRenewedBanner";
import {RenewalDeclinedBanner} from "../../../../../components/banners/RenewalDeclinedBanner";
import {AutoRenewalInviteBanner} from "../../../../../components/banners/AutoRenewalInviteBanner";
import {PolicyWillBeRenewedConfirmation} from "../../../../../components/modals/PolicyWillBeRenewedConfirmation";
import {AutoRenewalInviteAfterLogin} from "../../../../../components/modals/AutoRenewalInviteAfterLogin";
import {NoActivePolicyBanner} from "../../../../../components/banners/NoActivePolicyBanner";
import {GracePeriodBanner} from "../../../../../components/banners/GracePeriodBanner";
import {MtaLimitWarningBanner} from "../../../../../components/banners/MtaLimitWarningBanner";
import {CoronaBanner} from "../../../../../components/banners/CoronaBanner";
import {ILookupService, Types as JourneyCoreTypeDefs} from "@athena-portal/plugin-journey";
import {ClaimImpactMtaSuccessModalWordingGenerator} from "../../../common/ClaimImpactMtaSuccessModalWordingGenerator";
import {StorageSuccessModal} from "../../../../../components/modals/StorageSuccessModal";
import {RenewNextYearConfirmationModal} from "../../../../../components/modals/RenewNextYearConfirmationModal";
import {AutoRenewalQuestionModal} from "../../../../../components/modals/AutoRenewalQuestionModal";
import {AnnualTiles} from "./AnnualTiles";
import {FutureMTAExplainedHeader} from "../yourCarsPage/FutureMTAExplainedHeader";
import {AutomaticRenewalSuccessModal} from "../../../../../components/modals/AutomaticRenewalSuccessModal";
import {SportsVoucherBanner} from "../../../../../components/banners/SportsVoucherBanner";
import {OverdueInstalmentBanner} from "../../../../../components/banners/OverdueInstalmentBanner";
import {LVDataLayerHelper} from "../../../../../utils/LVDataLayerHelper";
import {DashcamBanner} from "../../../../../components/banners/DashcamBanner";
import {OutstandingPaymentBanner} from "../../../../../components/banners/OutstandingPaymentBanner";
import {SportsPassBanner} from "../../../../../components/banners/SportsPassBanner";
import {NCDImpactedClaimBanner} from "../../../../../components/banners/NCDImpactedClaimBanner";
import {UpcomingReplaceCarCoverBanner} from "../../../../../components/banners/UpcomingReplaceCarCoverBanner";
import {DirectDebitProposalModal} from "../../../../../components/modals/DirectDebitProposalModal";
import {QuickQuoteBanner} from "../../../../../components/banners/QuickQuoteBanner";
import {pushToAdobeDataLayerDelayed, putCustomerDetailsIntoAdobeDataLayer} from "../../../../../utils/AdobeDataLayerHelper";
import {GracePeriodModal} from "../../../../../components/modals/GracePeriodModal";
import {DashboardCarousel} from "../../../../../components/banners/carouselBanners/DashboardCarousel";
import {NewQuoteModalPopUp} from "../../../../../components/modals/NewQuoteModalPopUp";
import {SuccessfulPurchaseModal} from "../../../../../components/modals/SuccessfulPurchaseModal";
import {AllianzOnlineBadge} from "../../../../../components/AllianzOnlineBadge";
import {LackOfFoundsDelinquencyBanner} from "../../../../../components/banners/LackOfFoundsDelinquencyBanner";
import {RefundPaymentDetailsUpdateBanner} from "../../../../../components/banners/RefundPaymentDetailsUpdateBanner";
import {LvToAllianzUKTransferBanner} from "../../../../../components/banners/LvToAllianzUKTransferBanner";
import { DashboardPagePlain, IBaseDashboardState, IDashboardParams } from "../../../common/dashboard/DashboardPagePlain";

const { CONTACT_US_URL } = resourcesHelper;

interface IMotorDashboardState extends IBaseDashboardState {
    claimSubmissionDate?: string;
    oldMissedPaymentProcess?: boolean;
    showFeedbackDialog: boolean;
    displayWillBeRenewedConfirmation: boolean;
    classifiersLoaded: boolean;
    mainCardId?: string;
    cardExpired?: boolean;
    registrationNumber?: string;
    paymentType: string;
    hasOldHomePolicies?: boolean;
    previousMonthlyPremium?: number;
    showDirectDebitProposalModal: boolean;
    isFirstPolicy?: boolean;
}

@authorize
export class AnnualMotorDashboardPagePlain extends DashboardPagePlain<IMotorDashboardState> {

    private static readonly ENABLE_AUTO_RENEWAL: string = "enable_auto_renewal";
    private successPopupTitle: React.ReactNode;
    private modalContent: React.ReactNode;
    private tourDriver: Driver;
    private mobileDetect: MobileDetect;
    private modalAnythingElseChangedTitle: string;
    private explanationAnythingElseWording: string;
    private urlParams = new URLSearchParams(window.location.search);
    private ignoreTour: boolean;

    @lazyInject(JourneyCoreTypeDefs.LookupService)
    private lookupService: ILookupService;

    constructor(props: IWithRouterProps<IDashboardParams>) {
        super(props);

        this.state = {
            ...this.state,
            classifiersLoaded: false,
            policiesProcessed: false,
            showFeedbackDialog: false,
            displayWillBeRenewedConfirmation: false,
            showRenewalSwitchConfirmation: false,
            showDirectDebitProposalModal: false,
            registrationNumber: '',
            paymentType: '',
        };

        this.tourDriver = new Driver({
            animate: false,
            onHighlightStarted: () => {
                if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                    // @ts-ignore
                    document.body.style["pointer-events"] = "none";
                }
                // @ts-ignore
                this.tourDriver["isOpen"] = true;
            },
            onHighlighted: () => {
                if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                    setTimeout(() => {
                        // @ts-ignore
                        document.body.style["pointer-events"] = "auto";
                    }, 500);

                }
            },
            onReset: () => {
                // @ts-ignore
                if (this.tourDriver["isOpen"]) {
                    // @ts-ignore
                    delete this.tourDriver["isOpen"];
                    this.setState({displayOverlay: true});
                    this.displayReviewDialog();
                    this.setState({displayOverlay: false});
                }
            },

        });

        this.setTour = this.setTour.bind(this);
        this.mobileDetect = new MobileDetect(window.navigator.userAgent);
    }

    public componentDidMount() {
        this.ignoreTour = false;
        this.setRedirections();

        const policyNumber: string = this.props.params.policyNumber;

        this.customerPortalService.getUserPoliciesWithLatestVersions().subscribe((policies: Policy[]) => {
            this.customerPortalService.getExpiredPolicies()
                .subscribe(expiredPolicies => {
                this.setState({
                    hasExpiredPolicies: Boolean(expiredPolicies && expiredPolicies.length > 0),
                    hasOldHomePolicies: this.filterByProduct(expiredPolicies, ProductsEnum.HOME).length > 0
                });
            });

            const wolfMotorPolicies:  Policy[] = [...policies]
                .filter((policy: Policy) => policy.products.includes(this.product))
                .sort((a, b) => moment(b.endDate).diff(a.endDate));
            const filteredPolicy: Policy = wolfMotorPolicies
                .filter((policy: Policy) => policy.policyNumber === this.props.params.policyNumber)[0];

            if (wolfMotorPolicies.length === 0) {
                this.setState({
                    policiesProcessed: true
                });
                return;
            }
            this.mountForPolicy(filteredPolicy);

            this.customerPortalService.getPolicyHistory().subscribe(
                (allPolicies: Policy[]) => {
                    let policy = wolfMotorPolicies.find(p => p.policyNumber === policyNumber);
                    const previousPolicyVersion = findPreviousPolicyVersionByAgreementVersion(allPolicies, this.props.params.policyNumber);
                    const uniquePolicies = new Set(allPolicies.map(p => p.policyNumber));
                    const isFirstPolicy = uniquePolicies.size === 1;

                    if (previousPolicyVersion) {
                        const previousInstalments = previousPolicyVersion.interaction.paymentDetails.instalmentPlan.instalments[0];
                        const previousMonthlyPremium = previousInstalments?.principal + previousInstalments?.interest;
                        this.setState({previousMonthlyPremium});
                    }

                    if (policy?.interaction.process === INTERACTION_PROCESS_MTA_REPLACE_CAR && moment().isBefore(policy.interaction.headerInfo.startDate)) {
                        policy = allPolicies.find(p => p.policyNumber === policy?.policyNumber && p.interaction.agreementVersion === policy.interaction.agreementVersion - 1);
                    }

                    if (policy?.policyHolder) {
                        putCustomerDetailsIntoAdobeDataLayer({
                            emailAddress: policy.policyHolder.email,
                            mobileNumber: policy.policyHolder.phoneMobile,
                            postcode: policy.policyHolder.address?.postalCode
                        });
                    }

                    this.setState({
                        isFirstPolicy,
                        registrationNumber: policy?.insuredVehicles[0].registrationNumber
                    });
                }
            );
            this.loadHasFailedCardRefundAndApplicableForDDValue(policyNumber);
        });

        this.fetchQuotes();

        this.lookupService.fetchLookupValues(`all${ProductsEnum.WOLF_MOTOR}`, "en-UK")
            .subscribe(() => {
                this.setState({classifiersLoaded: true})
            });

        this.pushToAdobeDataLayerTimeout = pushToAdobeDataLayerDelayed(2000);
    }

    componentWillUnmount() {
        clearTimeout(this.pushToAdobeDataLayerTimeout);
        this.ignoreTour = true;
    }

    private mountForPolicy = (policy: Policy) => {
        policy.interaction?.agreementVersionId ?
            this.fetchInstalmentInfos(policy) :
            this.setState({instalmentInfoLoaded: true})

        this.setState({
            policy,
            policiesProcessed: true
        });
        this.loadPartyAndMarketingPreferences();

        this.customerPortalService.getRenewalProposal(policy.policyNumber).subscribe(
            (renewalProposal: Renewal) => {
                this.setState({
                    renewalProposal
                });

                if (this.urlParams.get(AnnualMotorDashboardPagePlain.ENABLE_AUTO_RENEWAL) === "true") {
                    const hasPendingRenewal: boolean = renewalProposal != null && renewalProposal.status === POLICY_STATUS_PENDING_RENEWAL;
                    if (hasPendingRenewal) {
                        this.setAutomaticRenewal(true);
                        this.setState({
                            displayWillBeRenewedConfirmation: true,
                        })
                    }
                }
            }
        );

        this.loadPolicyHistoryAfterRenewal();

        this.customerPortalService.getPolicyPaymentTypeByPolicyNumber(this.props.params.policyNumber).subscribe((paymentType: any) => {
            this.setState({
                paymentType
            });
        });

        this.customerPortalService.getPolicyPropertiesByPropertyKeys(this.props.params.policyNumber,
            [PolicyPropertyEnum.AUTOMATIC_RENEWAL, PolicyPropertyEnum.PERFORM_RENEWAL, PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD, PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED, PolicyPropertyEnum.REUSE_MAIN_CARD])
            .pipe(finalize(() => this.setState({policyPropertiesLoaded: true})))
            .subscribe(
                (properties: PolicyProperty[]) => {
                    properties.forEach(property => {
                        if (property.key === PolicyPropertyEnum.AUTOMATIC_RENEWAL) {
                            this.setState({automaticRenewal: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.PERFORM_RENEWAL) {
                            this.setState({performRenewal: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.MAIN_ANNUAL_PAYMENT_CARD) {
                            this.setState({mainCardId: property.value});
                        } else if (property.key === PolicyPropertyEnum.ANNUAL_MONTHLY_OPTION_CARD_EXPIRED) {
                            this.setState({cardExpired: property.value === 'true'});
                        } else if (property.key === PolicyPropertyEnum.REUSE_MAIN_CARD) {
                            this.setState({reuseCard: property.value === 'true'})
                        }
                    })
                }
            );
    }

    private readonly updateMarketingPreferenceCheckboxState = (key: string) => {
        this.setState(prevState => ({
            marketingPreferenceCheckboxStates: {
                ...prevState.marketingPreferenceCheckboxStates,
                [key]: !prevState.marketingPreferenceCheckboxStates[key]
            },
            marketingPreferencesEdited: true
        }));
    };

    public render() {
        const annualHomeEnabled: boolean = process.env.REACT_APP_ANNUAL_HOME_ENABLED ? JSON.parse(process.env.REACT_APP_ANNUAL_HOME_ENABLED) : false;
        const {
            policy,
            hasExpiredPolicies,
            hasOldPolicies,
            party,
            quotesLoaded,
            instalmentInfoLoaded,
            policiesProcessed,
            cardRefundStatusChecked
        } = this.state;
        const dataLoaded = policiesProcessed && instalmentInfoLoaded && (!policy || party && quotesLoaded)
            && (hasExpiredPolicies != null || hasOldPolicies != null) && policiesProcessed && cardRefundStatusChecked;

        // Recreate DataLayer
        if (policy) {
            const interaction = policy.interaction;
            new LVDataLayerHelper().mapInteractionToDataLayer(interaction);
        }

        this.referrerJourney = window.sessionStorage.getItem("referrerJourney");
        this.showSuccessPopup = window.sessionStorage.getItem("showPopup");
        const onClose = this.setPopups();

        return (
            <>
                <Overlay show={!dataLoaded || this.state.displayOverlay || !this.state.classifiersLoaded}/>
                {(this.doRedirectToAllianzOnlinePage()) && (<Navigate to={`/allianzOnline?dashboard=true`}/>)}
                {isAllianzAdvantagesToggleEnabled() && this.doRedirectToAllianzPromotionPage() && (<Navigate to={`/allianzPromotion`}/>)}
                {this.showSuccessPopup && dataLoaded && (
                    this.renderSuccessModal(onClose)
                )}
                {this.state.showRenewalSwitchConfirmation &&
                    <RenewNextYearConfirmationModal product={ProductsEnum.WOLF_MOTOR}/>}
                <FalconHeader/>
                <div className="page-contents dashboard-page pt-3">
                    {policy?.interaction?.product === ProductsEnum.WOLF_MOTOR &&
                        <AllianzOnlineBadge policyView={true}/>}
                    <FalconNavigatorHeader
                        back={{
                            link: "/dashboard",
                            hidden: !this.multiPolicyAccount
                        }}
                        title={this.multiPolicyAccount ? `${resourcesHelper.PRODUCT} Car Insurance` : `Hi ${policy?.policyHolder.firstName ?? ""}`}
                    >
                        {policy && (
                            <div className="number-plate-preview mx-0 mb-4">
                                {this.state.registrationNumber}
                            </div>
                        )}
                    </FalconNavigatorHeader>
                    {dataLoaded && policy && (
                        <>
                            {policy && <DashboardCarousel newCarQuotePopUp={this.showNewCarQuotePopUp}
                                                          newHomeQuotePopUp={this.showNewHomeQuotePopUp}
                                                          quotes={this.state.quotes}
                                                          policy={policy}
                                                          product={ProductsEnum.WOLF_MOTOR} {...this.props}
                                                          marketingPreferenceCheckboxStates={this.state.marketingPreferenceCheckboxStates}/>}
                            {this.state.newQuotePopUpForProduct !== "" &&
                                <NewQuoteModalPopUp product={this.state.newQuotePopUpForProduct}
                                                    policy={policy} {...this.props}/>}
                            {this.renderBanners()}
                            <AnnualTiles
                                policies={[policy]}
                                renewalProposal={this.state.renewalProposal}
                                policyNumber={this.props.params.policyNumber}
                                hasExpiredPolicies={this.state.hasExpiredPolicies}
                                hasOldPolicies={this.state.hasOldPolicies}
                                hasMultiplePolicies={this.multiPolicyAccount}
                                renewalEnabled={this.state.performRenewal === true}
                                hasOldHomePolicies={this.state.hasOldHomePolicies}
                                quotes={this.state.quotes}
                                tourDriver={this.tourDriver}
                                {...this.props}
                            />
                            {annualHomeEnabled && this.state.policy!.interaction.policyHolder.ownsHome
                                && <QuickQuoteBanner
                                    policyHolder={this.state.policy!.policyHolder}
                                    policy={policy}
                                    {...this.props}/>}
                            <LvToAllianzUKTransferBanner product={ProductsEnum.WOLF_MOTOR} showTitle={true}/>
                        </>
                    )}
                    {this.multiPolicyAccount && <BackButton isTop={false} link={"/dashboard/"}/>}
                </div>
                <FalconFooter/>
            </>
        )
    }

    public componentDidUpdate(prevProps: Readonly<IWithRouterProps<IDashboardParams>>, prevState: Readonly<IMotorDashboardState>, snapshot?: any) {
        const {
            policy,
            hasExpiredPolicies,
            hasOldPolicies,
            party,
            quotesLoaded,
            instalmentInfoLoaded,
            policiesProcessed
        } = this.state;
        const dataLoaded = policiesProcessed && instalmentInfoLoaded && (!policy || party && quotesLoaded)
            && (hasExpiredPolicies != null || hasOldPolicies != null) && policiesProcessed;

        if (dataLoaded && !this.ignoreTour && getSessionStorage("prepareTour") && this.state.isFirstPolicy === true && this.tourStepsReady()) {
            this.ignoreTour = true;
            this.setTour();
            setSessionStorage("prepareTour", false)
        }
    }

    private renderBanners(): React.ReactNode {
        const {
            party,
            renewalProposal
        } = this.state;

        const policy: Policy = this.state.policy!;
        if (!policy) {
            return <></>;
        }

        const interaction = policy.interaction;
        const showCardExpiryBanner: boolean = this.state.cardExpired !== undefined;
        const vehicle: any = interaction.vehicles[0];
        const isDirectDebitPaymentType: boolean = this.state.paymentType === "directDebit";
        const isDirectDebitDetailsSet: boolean = renewalProposal?.paymentDetails.directDebitDetails !== undefined;

        const annualPolicyInfo = policy.annualPolicyInfo;
        const hasUnpaidChange = policy.annualPolicyInfo.hasUnpaidChange;
        const hasUnpaidChargebackInvoice = policy.annualPolicyInfo.hasUnpaidChargebackInvoice;
        const upcomingMtaDate = annualPolicyInfo.maxFutureMtaDate;

        const showFutureMTAHeader: boolean = upcomingMtaDate != null && interaction && interaction.process !== INTERACTION_PROCESS_MTC && !hasUnpaidChange;
        const hasPendingRenewal: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_PENDING_RENEWAL);
        const hasRenewalDeclined: boolean = this.verifyRenewalProposalStatus(POLICY_STATUS_UNDERWRITING_FAILURE);
        const hasPolicies = !!policy;
        const hasActivePolicy: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const policyCanceled = policy.status === POLICY_STATUS_MTC;
        const policyNumber = policy.policyNumber;
        const closedRenewalInvite: boolean = window.sessionStorage.getItem(SESSION_STORAGE_KEY_RENEWAL_PROPOSAL_CLOSED + policyNumber) === "true";
        const today = moment().utc().startOf("day");
        const gracePeriod: boolean = renewalProposal != null && today.isSameOrAfter(moment.utc(renewalProposal.headerInfo.startDate).startOf("day"));
        // This is special case for 2 unpaid instalments
        const showMissedPayment: boolean = !!annualPolicyInfo && annualPolicyInfo.hasDebt;
        let showOverdueInstalmentsBanner: boolean = false;
        showOverdueInstalmentsBanner = CommonHelpers
            .showOverdueInstalmentBanner(showMissedPayment, interaction, isDirectDebitPaymentType, showOverdueInstalmentsBanner, annualPolicyInfo);

        const ncdImpactedClaim: boolean = interaction.uistate.policyHasNcdImpactedClaims;
        const renewalProposalMonthly: boolean = renewalProposal?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;

        const directDebitProposalsEnabled: boolean = process.env.REACT_APP_MONTHLY_CARD_TO_MONTHLY_DIRECT_DEBIT_ENABLED ? JSON.parse(process.env.REACT_APP_MONTHLY_CARD_TO_MONTHLY_DIRECT_DEBIT_ENABLED) : false;
        const renewalProposalMonthlyAndNotDirectDebit: boolean =
            renewalProposalMonthly && !isDirectDebitPaymentType && !isDirectDebitDetailsSet;
        const isMonthly: boolean = interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;
        const showNcdImpactedClaimBanner: boolean = this.showNcdImpactedClaimBanner(isMonthly, interaction);
        const lackOfFoundsForMtc: boolean = this.isLackOfFundsMtc(interaction.process, annualPolicyInfo);

        const showNoActivePolicyBanner = this.showNoActivePolicyBanner(policy, showMissedPayment, renewalProposal);
        const showAnnualProductPaymentMessageBanner = this.showAnnualProductPaymentMessageBanner(policy, showOverdueInstalmentsBanner);

        return (
            <>
                <SportsVoucherBanner/>
                <DashcamBanner/>
                {hasActivePolicy && <SportsPassBanner/>}
                <UpcomingReplaceCarCoverBanner policyNumber={policyNumber}/>
                {showFutureMTAHeader && <FutureMTAExplainedHeader
                        policyNumber={policyNumber}
                        policyEndDate={policy.endDate}
                        isEligibleForEnhancedCourtesyCar={interaction.uistate.isEligibleForEnhancedCourtesyCar} />}
                {interaction && <MtaLimitWarningBanner interaction={interaction}/>}
                {(this.state.hasExpiredPolicies || this.state.hasOldPolicies) && <CoronaBanner/>}
                {this.state.policyPropertiesLoaded && !hasPendingRenewal && !this.state.performRenewal && !this.state.automaticRenewal && !policyCanceled &&
                    <NextYearAutoRenewalBanner turnOnNextYearRenewal={this.turnOnNextYearRenewal} setPerformRenewal={this.setPerformRenewal}/>
                }
                {showNcdImpactedClaimBanner && <NCDImpactedClaimBanner product={ProductsEnum.WOLF_MOTOR}/>}
                {lackOfFoundsForMtc && <LackOfFoundsDelinquencyBanner
                    interaction={interaction}
                    policyInfo={annualPolicyInfo}
                    amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                    reuseCard={this.state.reuseCard}
                />}
                {showAnnualProductPaymentMessageBanner && (
                    <AnnualProductPaymentMessageBanner
                        showInfoModal={false}
                        interaction={interaction}
                        showMissedPaymentBanner={showMissedPayment}
                        instalmentsInfo={this.getInstalmentsInfoForBanner(showNcdImpactedClaimBanner)}
                        hasRenewalDeclined={hasRenewalDeclined}
                        policyInfo={annualPolicyInfo}
                        amount={isMonthly ? annualPolicyInfo.overdueMonthlyInvoiceAmount : annualPolicyInfo.overdueAnnualInvoiceAmount}
                        ncdImpactedClaim={ncdImpactedClaim}
                        reuseCard={this.state.reuseCard}
                    />)}
                {annualPolicyInfo && !lackOfFoundsForMtc && showOverdueInstalmentsBanner && (
                    <OverdueInstalmentBanner amount={annualPolicyInfo.overdueMonthlyInvoiceAmount}
                        unpaidInstallmentIdToAmount={annualPolicyInfo.unpaidInstallmentIdToAmount}
                        policyNumber={interaction.agreementNumber}
                        product={ProductsEnum.WOLF_MOTOR}
                        reuseCard={this.state.reuseCard}
                    />
                )}
                {hasUnpaidChange && <UnpaidChangeBanner unpaidChangeDueDate={annualPolicyInfo.unpaidChangeDueDate}
                                        interaction={interaction}/>}
                {hasUnpaidChargebackInvoice && !isDirectDebitPaymentType &&
                    <ChargebackBanner
                        premiumType={interaction.factors.premiumType}
                        policyNumber={policyNumber}
                    />
                }
                {hasUnpaidChargebackInvoice && !!policy?.annualPolicyInfo.unpaidChargebackInvoiceAmount && isDirectDebitPaymentType &&
                    <OutstandingPaymentBanner
                        amount={policy.annualPolicyInfo.unpaidChargebackInvoiceAmount}
                        policyNumber={policy.policyNumber}
                        product={interaction.product}
                    />
                }
                {showCardExpiryBanner && <CardExpiryBanner
                    party={party!}
                    mainCardId={this.state.mainCardId!}
                    policyNumber={policy.policyNumber}
                    annualMonthlyOptionCardExpired={this.state.cardExpired!}
                />}
                {hasPendingRenewal && !gracePeriod && (this.state.automaticRenewal || this.state.performRenewal) &&
                    <PolicyWillBeRenewedBanner
                        renewalProposal={renewalProposal}
                        product={ProductsEnum.WOLF_MOTOR}
                        productContent={<>{vehicle.make} {vehicle.model} {vehicle.registrationNumber}</>}
                        monthlyInstalmentsAllowed={InteractionHelper.isMonthlyQuoteAllowed(this.state.renewalProposal)}
                    />
                }
                {hasRenewalDeclined && hasPolicies && !policyCanceled &&
                    <RenewalDeclinedBanner
                        product={ProductsEnum.WOLF_MOTOR}
                        endDate={policy.endDate}
                        productWording={<>your {vehicle.make} {vehicle.model} {vehicle.registrationNumber}</>}
                    />
                }
                {showNoActivePolicyBanner && !this.multiPolicyAccount &&<NoActivePolicyBanner/>}
                {hasPendingRenewal && !this.state.automaticRenewal && this.state.performRenewal === false && !gracePeriod &&
                    <AutoRenewalInviteBanner
                        renewalProposal={this.state.renewalProposal!}
                        setAutomaticRenewal={this.setAutomaticRenewal}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        monthlyInstalmentsAllowed={InteractionHelper.isMonthlyQuoteAllowed(this.state.renewalProposal)}
                        renewalEditUrl={RENEWAL_PROPOSAL_EDIT_VIEW_JOURNEY_URL}
                        productWording={
                            <>
                                Your {resourcesHelper.PRODUCT} Car Insurance policy
                                for <strong>{vehicle.make} {vehicle.model} ends
                                on {formatDateTime(policy.endDate)}.</strong>{' '}
                                Until then you're still covered.
                            </>
                        }
                    />
                }
                {hasPendingRenewal && this.state.displayWillBeRenewedConfirmation && !gracePeriod &&
                    <PolicyWillBeRenewedConfirmation
                        currentPolicy={policy}
                        party={party!}
                        mainCardId={this.state.mainCardId!}
                        renewalProposal={this.state.renewalProposal!}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        showAutoRenewalQuestionModal={
                            (directDebitProposalsEnabled && renewalProposalMonthlyAndNotDirectDebit)
                                ? this.showDirectDebitProposalModal : this.showAutoRenewalQuestionModal}
                    />}
                {!this.hideAutoRenewalBanner && hasPendingRenewal && !closedRenewalInvite && !this.state.displayWillBeRenewedConfirmation && this.state.performRenewal === false && !gracePeriod &&
                    <AutoRenewalInviteAfterLogin
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                        isAutoRenewal={this.state.automaticRenewal}/>}
                {hasPendingRenewal && !this.state.automaticRenewal && gracePeriod &&
                    <GracePeriodBanner
                        renewalProposal={this.state.renewalProposal!}
                        vehicle={vehicle}
                        policy={policy}
                        interaction={interaction}
                    />}
                {hasPendingRenewal && !this.state.automaticRenewal && gracePeriod &&
                    <GracePeriodModal
                        currentPolicy={policy}
                        renewalProposal={this.state.renewalProposal!}
                        setPerformRenewal={this.setPerformRenewal}
                        showHideWillBeRenewedConfirmation={this.showHideWillBeRenewedConfirmation}
                    />}
                {hasPendingRenewal && renewalProposalMonthlyAndNotDirectDebit &&
                    this.state.showDirectDebitProposalModal && !this.state.automaticRenewal &&
                    <DirectDebitProposalModal
                        renewalProposal={this.state.renewalProposal!}
                        onSave={this.showAutoRenewalQuestionModal}
                        ddSelected={this.setAutomaticRenewalMonthlyDD}
                        {...this.props}
                    />}
                {(this.state.showAutoRenewalQuestionModal && !this.state.automaticRenewal) &&
                    <AutoRenewalQuestionModal
                        onSave={this.setAutomaticRenewalAndCloseAutoRenewalQuestionModal}
                        product={ProductsEnum.WOLF_MOTOR}
                    />}
                {(this.state.showAutoRenewalQuestionSuccessModal) && this.state.performRenewal !== undefined &&
                    <AutomaticRenewalSuccessModal
                        automaticRenewal={this.state.automaticRenewal}
                        nextYearRenewal={this.state.performRenewal}
                        product={ProductsEnum.WOLF_MOTOR}
                        closeSuccessModal={this.closeAutoRenewalQuestionSuccessModal}
                    />}
                {(this.state.hasFailedCardRefundAndApplicableForDD) &&
                    <RefundPaymentDetailsUpdateBanner
                        policyNumber={policy.policyNumber}
                        showPolicyNumber={false}
                    />}
            </>
        );
    }

    private verifyRenewalProposalStatus(checkStatus: string) {
        return this.state.renewalProposal != null && this.state.renewalProposal.status === checkStatus;
    }

    protected readonly continueAfterSuccessPopupClose = (): void => {
        if (resourcesHelper.THEME === "Britannia") {
            this.clearSessionStorage();
            if (this.state.isFirstPolicy === true) {
                this.setTour();
            }
        } else {
            this.clearSessionStorage();
            if (this.state.isFirstPolicy === true) {
                setSessionStorage("prepareTour", true);
            }
            this.ignoreTour = true;
            this.setRedirectToAllianzPromotionPage();
        }
    };

    private clearSessionStorage = (): void => {
        window.sessionStorage.removeItem("cancellationFeeReimbursementIssued");
    };

    private getTourSteps(): Driver.Step[] {
       return [
            {
                element: "#carTile",
                popover: {
                    className: "tour",
                    title: "View and make policy changes",
                    description: `Add driver(s), replace car, modify optional extras, modify your car or driver(s) details, all available here.
                                <div>
                                <ul class="nav-dots">
                                    <li class="nav-dot nav-dot-active"></li>
                                    <li class="nav-dot"></li>
                                    <li class="nav-dot"></li>
                                    <li class="nav-dot"></li>
                                </ul>
                                </div>`,
                    position: "bottom-right",
                    nextBtnText: "Next tip",
                    prevBtnText: "Skip tour"
                },
                onPrevious: () => {
                    // TODO: this is workaround fix for driver.js bug https://github.com/kamranahmedse/driver.js/issues/247
                    // fix is taken from https://github.com/kamranahmedse/driver.js/issues/247#issuecomment-774016683
                    // related technical debt ticket https://lv-digital.atlassian.net/browse/FAL-18588
                    if (this.mobileDetect.mobile() || this.mobileDetect.tablet()) {
                        // @ts-ignore
                        document.body.style["pointer-events"] = "none";
                        setTimeout(() => {
                            // @ts-ignore
                            document.body.style["pointer-events"] = "auto";
                        }, 500);
                    }
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#paymentTile",
                popover: {
                    className: "tour",
                    title: "View and amend payment details",
                    description: `Here you can view a history of your payments, set a new payment day
                    or change your card
                    <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                        </ul>
                    </div>`,
                    position: "bottom-left",
                    nextBtnText: "Next tip",
                    prevBtnText: "Skip tour",
                },
                onPrevious: () => {
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#policyDocumentsTile",
                popover: {
                    className: "tour",
                    title: "Policy documents",
                    description: `This is where you can view and print your policy documents
                   or check the emails we've sent to you
                   <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                                <li class="nav-dot"></li>
                        </ul>
                    </div>`,
                    position: "bottom-right",
                    prevBtnText: "Skip tour",
                    nextBtnText: "Next tip"
                },
                onPrevious: () => {
                    this.tourDriver?.reset();
                },
            },
            {
                element: "#claimsTile",
                popover: {
                    className: "tour",
                    title: "Report a claim online",
                    description: `Here you can make a windscreen, breakdown or all the other type of claims. We have 24 hours helpline
                    <div>
                        <ul class="nav-dots">
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot"></li>
                                <li class="nav-dot nav-dot-active"></li>
                        </ul>
                    </div>`,
                    position: "bottom-left",
                    prevBtnText: "Restart tour",
                    doneBtnText: "End tour"
                },
                onPrevious: () => {
                    this.tourDriver?.start(1);
                },
            }
        ];
    }

    private tourStepsReady(): boolean {
        const tourSteps = this.getTourSteps();


        return tourSteps.every(step => {
            if (typeof step.element === "string") {
                return !!document.querySelector(step.element);
            }

            return step.element instanceof Node && document.contains(step.element);
        })
    }

    private setTour(): void {
        this.tourDriver?.reset();
        this.tourDriver?.defineSteps(this.getTourSteps());
        this.tourDriver?.start();
    }

    private renderSuccessModal(onClose: any): React.ReactNode {
        if (this.referrerJourney === INTERACTION_PROCESS_NB) {
            return <SuccessfulPurchaseModal
                headerText={this.successPopupTitle}
                modalContent={this.modalContent}
                onClose={this.closeSuccessPopup}
            />
        } else {
            return <StorageSuccessModal
                title={this.successPopupTitle}
                explanationWording={this.modalContent}
                anythingElseTitle={this.modalAnythingElseChangedTitle}
                explanationAnythingElseWording={this.explanationAnythingElseWording}
                onClose={onClose}
            />
        }
    }

    private getSuccessPopupTitle(monthly: boolean): React.ReactNode {

        if (monthly) {
            return resourcesHelper.THEME === "Allianz"
                ? "Deposit payment complete"
                : <>Deposit payment <span className="title-highlight">complete</span></>;
        } else {
            return resourcesHelper.THEME === "Allianz"
                ? "Payment complete"
                : <>Payment <span className="title-highlight">complete</span></>;
        }
    }

    private setSuccessfulPaymentPopup = (): void => {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        const monthly = policy.interaction?.factors?.premiumType === AnnualPolicyPremiumTypeEnum.MONTHLY;

        this.successPopupTitle = this.getSuccessPopupTitle(monthly);

        const cancellationFeeReimbursementIssued = window.sessionStorage.getItem("cancellationFeeReimbursementIssued") === "true";

        this.modalContent = (
            <div>
                <h3 className="font-weight-bold mb-4">
                    Thanks {policy.policyHolder.firstName}
                </h3>

                <p className="mb-3">
                    When you’re ready, check your documents in{" "}
                    {resourcesHelper.THEME === "Allianz" ? (
                        <a
                            className="link"
                            href={`/dashboard/annualMotorDocuments/${this.props.params.policyNumber}`}
                        >
                            your {resourcesHelper.THEME} account
                        </a>
                    ) : (
                        <a
                            className="link"
                            href={`/dashboard/annualMotorDocuments/${policy.policyNumber}`}
                        >
                            your online account
                        </a>
                    )}
                    . This is also where you’ll manage your policy and make any changes.
                </p>

                {cancellationFeeReimbursementIssued && (
                    <p className="mb-3">
                        As promised, we'll refund you £40 to your registered payment card to
                        reimburse you for the cancellation fee that you previously paid.
                        The money should be with you shortly (it may take up to 5 days).
                    </p>
                )}

                {monthly && (
                    <p className="mb-3">
                        Your Direct Debit instruction will be confirmed to you by email within
                        3 working days or no later than 10 working days before the first collection.
                    </p>
                )}

                <p className="mb-4">
                    Remember, we’re just a phone call away if you need to claim,
                    for everything else it’s over to you! If you get stuck, email us and
                    we’ll reply within 24 hours.
                </p>

                {this.state.showMarketingPreferencesInSuccessPopup && (
                    <div className="inner-container marketing-preference marketing-preference--compact">
                        <div className="panel-detail-output-entity text-left">
                            <div className="widget marketing-widget">
                                <div>
                                    <h3 className="font-weight-bold mb-4">
                                        Don't miss out, we'd love to keep you up to date
                                    </h3>
                                    <p className="margin-bottom-20">
                                            <span className="font-weight-semi-bold">
                                                How would you like to hear about our latest offers, products and discounts?
                                            </span>{" "}
                                        You can opt in or out at any time from your account.
                                    </p>
                                </div>
                                <div className="checkBox">
                                    {this.renderMarketingPreferenceCheckboxes(this.marketingPreferenceCheckboxes)}
                                </div>
                                {isAllianzAdvantagesToggleEnabled() && (
                                <div>
                                    <p>
                                        Just so you know, if you don’t opt in to our emails, we won’t be able to
                                        send
                                        you our newsletter with the latest offers and rewards for being an Allianz
                                        customer such as priority rugby tickets and an exclusive dashcam discount.
                                        Don’t miss out!
                                    </p>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {resourcesHelper.THEME === "Allianz" ? (
                    <>
                        <p>
                            To use our live chat{" "}
                            <img
                                src={`/${resourcesHelper.THEME}/img/chat.svg`}
                                alt="Chat"
                            />{" "}
                            please visit our{" "}
                            <a
                                className="help-popup-hyperlink-style"
                                href={CONTACT_US_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                contact page
                            </a>.
                        </p>

                        <p className="mt-3 font-weight-bold">
                            Welcome to the {resourcesHelper.THEME} family!
                        </p>

                        <div className="d-flex">
                            <img
                                src="/Allianz/img/allianz-olympic-logo.svg"
                                alt={`${resourcesHelper.THEME} olympics logo`}
                            />
                        </div>
                    </>
                ) : (
                    <p className="mt-3 font-weight-bold">
                        Welcome to the Britannia Insurance family!
                    </p>
                )}
            </div>
        );
    };

    private readonly renderMarketingPreferenceCheckboxes = (preferences: any[]) => {
        return preferences.map(value => (
            <label key={value.type} className={`${value.className}-preference`}>
                <input
                    type="checkbox"
                    name={value.type}
                    id={value.type}
                    aria-label={value.label}
                    checked={this.state.marketingPreferenceCheckboxStates[value.type]}
                    onChange={() => this.updateMarketingPreferenceCheckboxState(value.type)}
                />
                <div className="checkbox">
                    <span className={`icon ${value.icon || value.className}-icon`}/>
                    <span className="text font-weight-semi-bold">{value.label}</span>
                </div>
            </label>
        ));
    };

    private setNewPaymentPopup(): void {
        this.successPopupTitle = "Payment was successful";
        this.modalContent = (
            <p>
                We’ve saved your changes and <b>{window.sessionStorage.getItem("paymentAmount")}</b> has been debited
                from your card.<br/>
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
        );
    }

    private setNewEditCarPopUp(monthlyPaymentSpreadAmount: number, monthlyPremium: number, previousMonthlyPremium: number | undefined): void {
        this.successPopupTitle = "Payment was successfully added to your payment plan";
        this.modalContent = (
            <div className="font-weight-extra-light">
                <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountToDisplay(previousMonthlyPremium)}
                </span> a month.
                </p>
                <p>The additional cost of <span className="font-weight-semi-bold">
                        {getAmountToDisplay(monthlyPaymentSpreadAmount)}
                    </span> has increased your remaining monthly payments to <span className="font-weight-semi-bold">
                {getAmountToDisplay(monthlyPremium)} / month.</span>
                </p>
            </div>
        );
        this.modalAnythingElseChangedTitle = "Has anything else changed?";
        this.explanationAnythingElseWording = "Please check everything’s still accurate and make any changes required so you can be sure all policy details are up to date.";
    }

    private setNewStartDatePopUp(): void {
        const date = window.sessionStorage.getItem("changedStartDate") ? window.sessionStorage.getItem("changedStartDate") : null;
        this.successPopupTitle = "Policy's start date has been changed";
        this.modalContent = (
            <p>
                Your policy will now start on <b>{formatDateDMY(date!)}</b>.
            </p>
        );
    }

    private setEditRenewalSaveSuccessPopup(): void {
        if (this.state.partyLoaded && this.state.mainCardId && this.state.renewalProposal && this.state.policyPropertiesLoaded) {

            let premiumToDisplay: number;
            let initialPaymentDate: string;
            const premiumType = this.state.renewalProposal!.factors.premiumType;
            if (premiumType === PREMIUM_TYPE_ANNUAL) {
                premiumToDisplay = this.state.renewalProposal!.factors.annualPremium;
                initialPaymentDate = moment.utc(this.state.renewalProposal.renewalDetails.annualPayerInitialPaymentDate, moment.ISO_8601).format("DD MMM YYYY");
            } else {
                premiumToDisplay = this.state.renewalProposal!.paymentDetails.instalmentPlan.monthlyPayment;
                initialPaymentDate = moment.utc(this.state.renewalProposal.paymentDetails.instalmentPlan.instalments[0].dueDate).format("DD MMM YYYY");
            }
            const paymentCard: PaymentCard | null = findMainAnnualPaymentCardByMainCardId(this.state.party!, this.state.mainCardId!);
            const startDate = moment(this.state.renewalProposal!.headerInfo.startDate!).format("DD MMMM YYYY");

            this.successPopupTitle = "All done! All the changes made to your renewal policy are saved.";
            this.modalContent = (
                <p>
                    <div className='renewal-save-change-success-modal mt-2'>
                        <div className='section-panel banner banner-info banner-info-multiple-paragraphs'>
                            <p className="mx-4 mb-0 grid-col-2"><strong>Heads up</strong> - if you need any changes to
                                start before your renewal date, go to {' '}
                                <a className="font-weight-bold text-decoration-underline"
                                   href={`/dashboard/annualMotor/yourCars/${this.props.params.policyNumber}`}>Your
                                    car, make changes.</a>
                            </p>
                        </div>
                        {premiumType === PREMIUM_TYPE_ANNUAL &&
                            <>
                                <div className='price-section'>Your new car insurance renewal price
                                    is <span className='price-bold'>{getAmountToDisplay(premiumToDisplay)}</span></div>
                                {this.state.automaticRenewal &&
                                    <div className='card-section'> and will be taken from your card endings
                                        in <span
                                            className='card-number-bold'>{paymentCard && paymentCard.cardNumberObfuscated.split('******')[1]}</span> on {startDate}.
                                    </div>
                                }
                            </>
                        }
                        {premiumType === PREMIUM_TYPE_MONTHLY && this.state.automaticRenewal &&
                            <>
                                <div className='price-section'>Your 1st payment of {' '}<span
                                    className='price-bold'>{getAmountToDisplay(premiumToDisplay)}</span>
                                </div>
                                will be taken from card
                                ending in {' '}<span
                                className='card-number-bold'>{paymentCard!.cardNumberObfuscated.split('******')[1]}</span> on {initialPaymentDate}.
                                Please check your payment plan for further dates and amounts.
                            </>
                        }
                        {this.state.automaticRenewal &&
                            <div>
                                {' '}Please <Link className="check-your-card-link" to="/dashboard/annualPaymentHistory"
                                                  onClick={() => window.sessionStorage.removeItem("showPopup")}>{' '}check
                                your payment card</Link> is still valid.
                            </div>
                        }
                    </div>
                </p>
            );
        }
    }

    private setEditRenewalSaveSuccessDDPopup(): void {
        this.successPopupTitle = "All done!";
        this.modalContent = (
            <p>
                <div className='renewal-save-change-success-modal mt-2'>
                    <div className='price-section'>All the changes made to your renewal policy are saved.</div>
                </div>
            </p>
        );
    }

    private setSaveClaimImpactPaymentSuccessPopup(): void {
        const policy: Policy = this.state.policy!;
        if (!policy) {
            return;
        }

        if (this.state.partyLoaded) {
            const interaction = policy.interaction;
            const {factors, uistate, paymentDetails, policyHolder, agreeToReuseCardDetails} = interaction;
            const mtaSuccessMessageText = window.sessionStorage.getItem("mtaSuccessMessageText");
            const wording = ClaimImpactMtaSuccessModalWordingGenerator.generateModalWording(
                factors, paymentDetails.instalmentPlan!.monthlyPayment, uistate.payFullPrice, mtaSuccessMessageText,
                policyHolder.cardDetails?.at(-1)?.number, agreeToReuseCardDetails);

            window.sessionStorage.removeItem("mtaHeadsUpMessageText");
            window.sessionStorage.removeItem("mtaSuccessMessageText");
            this.successPopupTitle = wording.modalTitle ? wording.modalTitle.toString() : "";
            this.modalContent = (<>{wording.modalBody}</>);
        }
    }

    private setSaveRenewalSuccessPopup(): void {
        if (this.state.partyLoaded && this.state.policyPropertiesLoaded) {
            const policy: Policy = this.state.policy!;
            if (!policy) {
                return;
            }

            const interaction = policy.interaction;
            const premiumType = interaction.factors.premiumType;
            const paymentDetails = interaction.paymentDetails;
            const paymentPlan = paymentDetails.instalmentPlan;
            const premiumToDisplay: number = premiumType === PREMIUM_TYPE_ANNUAL ? interaction.factors.annualPremium : paymentPlan.monthlyPayment;
            const premiumChangedToMonthly: boolean = interaction.renewalDetails?.lyPremiumType === PREMIUM_TYPE_ANNUAL && interaction.factors.premiumType === PREMIUM_TYPE_MONTHLY;
            const firstInstallment: number = paymentPlan.instalments[0].principal + paymentPlan.instalments[0].interest;
            const cardEnding: string = interaction.policyHolder.cardDetails?.at(-1)?.number.slice(-4);
            const vehicle: any = interaction.vehicles[0];
            const firstInstalmentPaymentDate = paymentDetails.paymentType === "card"
                ? moment(interaction.renewalDetails.monthlyPayerInitialPaymentDate).format("DD MMMM YYYY")
                : moment(paymentPlan.instalments[0].dueDate).format("DD MMMM YYYY");

            this.successPopupTitle = premiumType === PREMIUM_TYPE_MONTHLY && !premiumChangedToMonthly ? `You have set up your ${vehicle.make}, ${vehicle.model} (${vehicle.registrationNumber}) car insurance policy to renew` : "Payment was successful";
            this.modalContent = (
                <p>
                    <div className='renewal-save-change-success-modal mt-2'>
                        {premiumType === PREMIUM_TYPE_ANNUAL &&
                            <>
                                <div className='price-section'><span
                                    className='price-bold'>{getAmountToDisplay(premiumToDisplay)}</span> was taken from
                                    your card ending in <span
                                        className='card-number-bold'>{cardEnding}</span>
                                    {" "}for renewing your {vehicle.make}, {vehicle.model} ({vehicle.registrationNumber})
                                    car policy.
                                    <p>
                                        Please allow a couple of minutes for the payment to be updated in your account.
                                    </p>
                                </div>
                                <div className='card-section'>
                                    Thanks choosing {resourcesHelper.THEME} for another year!
                                </div>
                            </>
                        }
                        {premiumType === PREMIUM_TYPE_MONTHLY &&
                            <>
                                <div className='price-section'>
                                    Your 1st payment of {' '}
                                    <span className='price-bold'>
                                        {getAmountToDisplay(firstInstallment)}
                                    </span>
                                </div>
                                will be taken from card ending in {' '}
                                <span className='card-number-bold'>
                                    {cardEnding}
                                </span> on {firstInstalmentPaymentDate}.
                                Please check your payment plan for further dates and amounts.
                                {' '}Please
                                <Link className="check-your-card-link" to="/dashboard/annualPaymentHistory"
                                      onClick={() => window.sessionStorage.removeItem("showPopup")}>{' '}
                                    check your payment card
                                </Link> is still valid.
                            </>}
                    </div>
                </p>
            );
        }
    }

    private showHideWillBeRenewedConfirmation = (display: boolean): void => {
        this.setState({
            displayWillBeRenewedConfirmation: display
        })
    }

    private showDirectDebitProposalModal = (): void => {
        this.setState({
            showDirectDebitProposalModal: true
        });
    }

    private setAutomaticRenewalMonthlyDD = (automaticRenewal: boolean): void => {
        // true when user accepted next year renewal in modal
        // auto renewal case must also set next year flag to true - FAL-38597
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(automaticRenewal);
        this.setState({
            showAutoRenewalQuestionModal: false,
            showDirectDebitProposalModal: false,
            showAutoRenewalQuestionSuccessModal: false,
            performRenewal: true,
            automaticRenewal
        })
    }

    private setAutomaticRenewalAndCloseAutoRenewalQuestionModal = (automaticRenewal: boolean): void => {
        // true when user accepted next year renewal in modal
        // auto renewal case must also set next year flag to true - FAL-38597
        this.setPerformRenewal(true);
        this.setAutomaticRenewal(automaticRenewal);
        this.setState({
            showAutoRenewalQuestionModal: false,
            showDirectDebitProposalModal: false,
            showAutoRenewalQuestionSuccessModal: true,
            performRenewal: true,
            automaticRenewal
        })
    }

    private setPopups(): any {
        let onClose;
        this.explanationAnythingElseWording = "";
        this.modalAnythingElseChangedTitle = "";
        if (this.referrerJourney === INTERACTION_PROCESS_NB) {
            onClose = this.closeSuccessPopup;
            this.setSuccessfulPaymentPopup();
        } else if (this.referrerJourney === NEW_PAYMENT) {
            window.sessionStorage.removeItem("paymentSettings");
            this.setNewPaymentPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_MTA_EDIT_CAR_DETAILS) {
            const factors = this.state.policy?.interaction.factors;
            if (factors) {
                const monthlyPaymentAmount: number = factors.monthlyPaymentSpreadWithInterestAmount || factors.monthlyPaymentSpreadAmount;
                this.setNewEditCarPopUp(monthlyPaymentAmount, factors.monthlyPremium, this.state.previousMonthlyPremium);
            }
        } else if (this.referrerJourney === INTERACTION_PROCESS_PENDING_RENEWAL) {
            this.setEditRenewalSaveSuccessPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_PENDING_RENEWAL_DD) {
            this.setEditRenewalSaveSuccessDDPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_RENEWAL) {
            if (!this.state.automaticRenewal) {
                onClose = this.showAutoRenewalQuestionModal;
            }
            this.setSaveRenewalSuccessPopup();
        } else if (this.referrerJourney === INTERACTION_PROCESS_MTA_NB_CHANGE_START_DATE) {
            this.setNewStartDatePopUp();
        } else if (this.referrerJourney === INTERACTION_PROCESS_CLAIM_IMPACT) {
            this.setSaveClaimImpactPaymentSuccessPopup();
        } else {
            window.sessionStorage.removeItem("showPopup");
            window.sessionStorage.removeItem("referrerJourney");
        }
        return onClose;
    }

    protected showNoActivePolicyBanner(policy: Policy, showMissedPayment: boolean, renewalProposal?: Renewal): boolean {
        const interaction = policy.interaction;
        const today = moment().utc().startOf("day");

        const hasActivePolicy: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSameOrAfter(moment(), 'day');
        const futureCancelledPolicyBeforeInception: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSame(moment.utc(policy.startDate, moment.ISO_8601))
            && moment.utc(policy.startDate, moment.ISO_8601).isAfter(moment(), 'day');
        const ncdImpactedClaim: boolean = interaction.uistate.policyHasNcdImpactedClaims;
        const gracePeriod: boolean = renewalProposal != null && today.isSameOrAfter(moment.utc(renewalProposal.headerInfo.startDate).startOf("day"));

        return (!hasActivePolicy || futureCancelledPolicyBeforeInception) && !ncdImpactedClaim && !gracePeriod && !showMissedPayment;
    }

    protected showAnnualProductPaymentMessageBanner(policy: Policy, showOverdueInstalmentsBanner: boolean): boolean {
        const interaction = policy.interaction;
        const annualPolicyInfo = policy.annualPolicyInfo

        const lackOfFoundsForMtc: boolean = this.isLackOfFundsMtc(interaction.process, annualPolicyInfo);
        const hasOverdueAnnualPayment = +annualPolicyInfo.overdueAnnualInvoiceAmount > 0;
        const futureCancelledPolicyBeforeInception: boolean = moment.utc(policy.endDate, moment.ISO_8601).isSame(moment.utc(policy.startDate, moment.ISO_8601))
            && moment.utc(policy.startDate, moment.ISO_8601).isAfter(moment(), 'day');

        return interaction && !lackOfFoundsForMtc && (!showOverdueInstalmentsBanner || hasOverdueAnnualPayment) && !futureCancelledPolicyBeforeInception;
    }

}

export const AnnualMotorDashboardPage = withRouter<{}, IDashboardParams>(AnnualMotorDashboardPagePlain)
